/** Display helpers. Wording follows the interface's plain-language voice. */

export function relativeTime(ms: number): string {
  if (!ms) return "never";
  const diff = Date.now() - ms;
  if (diff < 0) return "just now";
  const s = Math.floor(diff / 1000);
  if (s < 45) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} day${d === 1 ? "" : "s"} ago`;
  return new Date(ms).toLocaleDateString();
}

export function dateTime(ms: number): string {
  if (!ms) return "—";
  return new Date(ms).toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function bytes(n: number): string {
  if (!n) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(units.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/** RustDesk IDs are nine digits; grouping them makes them readable aloud. */
export function deviceId(id: string): string {
  if (!/^\d{9}$/.test(id)) return id;
  return `${id.slice(0, 3)} ${id.slice(3, 6)} ${id.slice(6)}`;
}

export function platformOf(os: string): string {
  const s = (os || "").toLowerCase();
  if (s.includes("windows")) return "Windows";
  if (s.includes("darwin") || s.includes("macos") || s.includes("mac os")) return "macOS";
  if (s.includes("android")) return "Android";
  if (s.includes("ios")) return "iOS";
  if (s) return "Linux";
  return "Unknown";
}
